export default function systemNotificationsDirective() {
  console.log('app.components.global.systemNotifications created');
  return {
    template: require('./system-notifications.directive.html'),
    controller: 'SystemNotificationsDirectiveController',
    controllerAs: 'systemNotificationsVM',
    bindToController: true,
    replace: true,
    scope: {},
  };
}
